import React, { useCallback, forwardRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import queryString from "query-string";

export const EntityLink = forwardRef(({ children, to, hashUrl, title, className, onClick, ...rest }, ref) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = useCallback(
    (event) => {
      if (hashUrl && !event.ctrlKey && !event.metaKey) {
        event.preventDefault();
        let args = { modal: hashUrl };

        if (hashUrl.includes("&")) {
          const parts = hashUrl.split("&");
          args.modal = parts[0];
          parts.shift();
          parts.forEach((segment) => {
            const [key, value] = segment.split("=");
            args = { ...args, [key]: value };
          });
        }

        const currentQueryParams = queryString.parse(location.search);
        const updatedQueryParams = {
          ...currentQueryParams,
          ...args,
        };
        const newUrl = `${location.pathname}?${queryString.stringify(updatedQueryParams, { sort: false })}`;

        navigate(newUrl);
      }
      typeof onClick === "function" && onClick(event);
    },
    [hashUrl, location.pathname, location.search, navigate, onClick]
  );

  return (
    <Link
      ref={ref}
      onClick={handleClick}
      className={className}
      to={to}
      title={title}
      {...rest}
    >
      {children}
    </Link>
  );
});

EntityLink.propTypes = {
  to: PropTypes.string.isRequired,
  hashUrl: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

EntityLink.displayName = "EntityLink";
